import React, {Component} from "react"
import styled from "styled-components"
import {MenuItem} from "react-bootstrap"
import {MutationFn, MutationResult} from "@irati/utils/apollo"

import {FormattedMessage} from "@irati/utils/lang"
import {Poll} from "@irati/types"
import DeletePollMutation from "@irati/recognition/apollo/mutation/Poll/Delete"
import MenuActionsBase, {MenuActionsProps} from "../../shared/MenuActions"
import Wrapper from "../shared/Poll/Wrapper"
import ConfirmDeletePoll from "../shared/Poll/ConfirmDeletePoll"

interface Props extends Partial<MenuActionsProps> {
  poll: Poll
  onDeleteSuccess: () => void
}

interface State {
  isDeleteMode: boolean
}

const MenuActions = styled(MenuActionsBase)`
  display: flex;
  justify-content: flex-end;
`

export default class PollActions extends Component<Props, State> {
  state = {
    isDeleteMode: false
  }

  enableDeleteMode = () => {
    this.setState({
      isDeleteMode: true
    })
  }

  disableDeleteMode = () => {
    this.setState({
      isDeleteMode: false
    })
  }

  render() {
    const {poll, onDeleteSuccess, ...props} = this.props
    const {isDeleteMode} = this.state

    return (
      <>
        <MenuActions pullRight item={poll} {...props} disabled={isDeleteMode}>
          {({isUserContent, canDeletePoll, isAdmin}) => [
            ((poll.active && !poll.archived && isUserContent && canDeletePoll) || isAdmin) && (
              <MenuItem key={1} onSelect={this.enableDeleteMode}>
                <FormattedMessage id="recognition.polls.openPoll.poll.btnDelete.label" />
              </MenuItem>
            )
          ]}
        </MenuActions>
        <Wrapper>
          {isDeleteMode && (
            <DeletePollMutation poll={poll} onCompleted={onDeleteSuccess}>
              {(mutate: MutationFn, apolloState: MutationResult) => (
                <ConfirmDeletePoll poll={poll} apolloState={apolloState} onCancel={this.disableDeleteMode} onConfirm={mutate} />
              )}
            </DeletePollMutation>
          )}
        </Wrapper>
      </>
    )
  }
}
